import { ChangeDetectionStrategy, Component, effect, inject, input, ViewEncapsulation } from '@angular/core';
import { IBlogArticleBlok, S1Layout } from '@seven1/model';
import { SeoService } from '@seven1/angular/seo';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { LayoutWrapper } from '@seven1/angular-storyblok-layout';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-blog-article-wrapper',
    imports: [CmsComponent, LayoutWrapper, NgClass],
    templateUrl: './article.wrapper.html',
    styleUrl: './article.wrapper.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'app-blog-article',
    }
})
export class BlogArticleWrapper {
    private _seo = inject(SeoService);
    block = input.required<IBlogArticleBlok>();
    layout = input.required<S1Layout>();

    constructor() {
        effect(() => {
            const blok = this.block();
            this._seo.addPageMeta(blok);
        });
    }
}
